/**
 * Constants configuration for debugging. This is the same as constants.js, except we can use these values if debugging is enabled and
 * we can also change the values through the simulation. The rocket values are based on Rocket Lab's Electron rocket.
 * (https://en.wikipedia.org/wiki/Electron_(rocket))
 */

data = [{

  // SIMULATION CONSTANTS

  gravity: 9.81,              // value for gravity force (N)
  coefficientOfDrag: 0.4,     // Cd (coefficient of drag of the rocket)
  airDensity: 1.2,            // p (air density - 1.2kg/m3 at sea level)
  diameter: 1.2,              // diameter (diameter of rocket (m))
  fuelConstant: (1 / 2990),   // fuel constant for calculating the fuel mass burned at every tick. Larger value means more fuel is burned.
  stressCoefficient: 25,      // this is the value that determines acceleration stress force mid flight
  payloadHeight: 400000,       // the minimum height at which the payload can be released
  cloudSpeed: 40,             // this sets how fast the clouds move. This is the number of pixels the cloud tween at every loop.

  // SLIDER CONSTANTS

  maxMass: 12500,             // maximum mass for the rocket (kg)
  minMass: 0,                 // minimum mass for the rocket (kg)
  initialMass: 1000,          // initial mass for the rocket (kg)

  maxThrust: 162000,          // maximum thrust for the rocket (N)
  minThrust: 100,             // minimum thrust for the rocket (N)
  initialThrust: 25000,       // initial thrust for the rocket (N)

  maxThrustTime: 140,         // maximum thrust time for the rocket (sec)
  minThrustTime: 0,           // minimum thrust time for the rocket (sec)
  initialThrustTime: 20       // initial thrust time for the rocket (sec)
}];

module.exports.debugConstants = data[0];
